import { combineReducers } from 'redux';
import SupportUsers from './SupportUsers/reducer';

export default combineReducers({
    SupportUsers
});



// WEBPACK FOOTER //
// ./environments/logging/data/reducer.js